import { render } from "./dotted-line.vue?vue&type=template&id=8ac18c1c&scoped=true"
import script from "./dotted-line.vue?vue&type=script&lang=js"
export * from "./dotted-line.vue?vue&type=script&lang=js"

import "./dotted-line.vue?vue&type=style&index=0&id=8ac18c1c&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac18c1c"]])

export default __exports__